import { downloadFile } from './browser';

export const serializeSvg = (svg: SVGSVGElement) => {
  return new XMLSerializer().serializeToString(svg);
};

export const downloadSvg = (svg: SVGSVGElement, fileName: string) => {
  downloadFile(new Blob([serializeSvg(svg)], { type: 'image/svg+xml' }), fileName);
};
